import React from "react";
import { IconInfo } from "./WireframeIcons";

type PatternFieldHelpProps = {
  text: string;
};

export function PatternFieldHelp({ text }: PatternFieldHelpProps) {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef<HTMLSpanElement | null>(null);

  React.useEffect(() => {
    if (!open) return;

    const handlePointerDown = (event: MouseEvent | TouchEvent) => {
      if (!rootRef.current) return;
      const target = event.target as Node | null;
      if (target && !rootRef.current.contains(target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("touchstart", handlePointerDown);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("touchstart", handlePointerDown);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  return (
    <span className="pattern-help" ref={rootRef}>
      <button
        type="button"
        className="pattern-help-trigger"
        aria-label="Cómo funciona este campo"
        onClick={() => setOpen(prev => !prev)}
      >
        <IconInfo className="w-4 h-4" />
      </button>
      {open ? <span className="pattern-help-bubble">{text}</span> : null}
    </span>
  );
}
